<template>
    <content-component>
        <template v-slot:table_create_button>
            <button class="btn custom-btn-02 w-100" @click="open_form_modal()">
                <i class="fas fa-plus"></i>
                Artikel
            </button>
        </template>
        <template v-slot:content_body>
            <div class="row g-3" v-if="data.length">
                <div v-for="(article, index) in data" :key="index" class="col-12 col-lg-4">
                    <div class="rounded shadow-sm">
                        <div class="custom-image-warpper position-relative" v-viewer="{toolbar: false, navbar: false, keyboard: false}">
                            <div class="custom-published" v-if="article.is_published == 1"><i class="fas fa-check"></i></div>
                            <img :src="article.image_url" alt="article-image">
                        </div>
                        <div class="d-flex justify-content-between custom-upload-preview-button">
                            {{ article.title }}
                            <div class="dropdown">
                                <button class="btn custom-btn-unborder-02 py-0" type="button" :id="`dropdownArticle${article.id}`" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <ul class="dropdown-menu" :aria-labelledby="`dropdownArticle${article.id}`">
                                    <li><span class="dropdown-item" @click="open_form_modal(article)">Ubah</span></li>
                                    <li><span class="dropdown-item" @click="delete_data(article.id)">Hapus</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="w-100 p-3 text-center">No Data.</div>
            </div>
        </template>
    </content-component>
    <article-form-modal ref="articleFormModal" :published="published" @close="close_modal"/>
</template>

<script>
	import ContentComponent from '@/components/external/ContentComponent'
    import ArticleFormModal from './ArticleFormModal'
    import { mapGetters } from 'vuex'
    import Swal from 'sweetalert2'

	export default {
        components: {
            'content-component': ContentComponent,
            'article-form-modal': ArticleFormModal,
        },
        data() {
            return {
                published: 0,
            }
        },
        computed: {
            ...mapGetters({
                data: 'article/getArticle',
            }),
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                this.$store.dispatch('article/getArticle').then((response) => {
                    if(response.status){
                        this.published = 0
                        for(let i = 0; i < response.data.length; i++){
                            if(response.data[i].is_published){
                                this.published++
                            }
                        }
                    }
                })
            },
            open_form_modal(value){
                this.$refs.articleFormModal.open_modal(value)
            },
            close_modal(value){
                if(value){
                    this.init()
                }
            },
            delete_data(id){
                let parent = this
                Swal.fire({
                    icon: 'warning',
                    title: 'Apakah anda yakin ingin menghapus data ini?',
                    reverseButtons: true,
                    showCancelButton: true,
                    cancelButtonText: parent.$root.swal('cancelButtonText'),
                    confirmButtonColor: parent.$root.swal('errorButtonColor'),
                    confirmButtonText: parent.$root.swal('deleteButtonText'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        parent.$store.dispatch('article/deleteArticle', id).then((response) => {
                            if(response.status){
                                parent.init()
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Berhasil menghapus data',
                                    confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                    confirmButtonText: parent.$root.swal('doneButtonText'),
                                })
                            }
                        })
                    }
                })
            },
        }
	}
</script>

<style scoped>
    .custom-published {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 23px;
        height: 23px;
        background-color: rgba(243, 124, 0, 1);
        color: rgba(255, 255, 255, 1);
        text-align: center;
        border-radius: 23px;
    }
</style>